import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { faAngleRight, faArrowUpFromBracket } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../services/apiService';
import SettingsTabs from '../../components/common/SettingsTabs';
import { toast } from 'react-toastify';
function SettingsGeneral() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        site_name: '',
        site_url: '',
        site_email: '',
        site_phone: '',
        helpdesk_support_phone: '',
        site_city: '',
        site_state: '',
        site_pincode: '',
        site_address: '',
        site_country: '',
        site_logo: null,
        site_mini_logo: null,
        restricted_email_domain:'',
    });
    const styles = {
        tagContainer: {
            display: "flex",
            flexWrap: "wrap",
            padding: "0px",
            border: "none",
            borderRadius: "5px",
        },
        tag: {
            display: "flex",
            alignItems: "center",
            backgroundColor: "#B8D7FF",
            borderRadius: "3px",
            padding: "5px",
            marginRight: "5px",
            marginBottom: "5px",
            fontWeight:"600",
        },
        removeButton: {
            marginLeft: "5px",
            border: "none",
            background: "transparent",
            cursor: "pointer",
            fontSize: "16px",
        },
    };
    const [restricted_email_domain, setRecruiterEmail] = useState([]);
    const [input2, setInput2] = useState("");
    const [errors, setErrors] = useState({});
    const [btnloading, setBtnLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [cancel, setCancels] = useState(false);
    const [errorsmessage, setErrorMessage] = useState('');
    const [preview, setPreview] = useState(null);
    const [previewMini, setpreviewMini] = useState(null);
    useEffect(() => {
        const fetchUserData = async () => {
            setLoading(true);
            try {
                const response = await apiService.postRequest(`/admin/get-protected-settings?settings_type=general`);
                const generaldata = response.data;
                setPreview(generaldata.site_logo);
                setpreviewMini(generaldata.site_mini_logo);
                setFormData({
                    site_name: generaldata.site_name || '',
                    site_url: generaldata.site_url || '',
                    site_phone: generaldata.site_phone || '',
                    helpdesk_support_phone: generaldata.helpdesk_support_phone || '',
                    site_email: generaldata.site_email || '',
                    site_address: generaldata.site_address || '',
                    site_city: generaldata.site_city || '',
                    site_state: generaldata.site_state || '',
                    site_country: generaldata.site_country || '',
                    site_pincode: generaldata.site_pincode || '',
                    restricted_email_domain: generaldata.restricted_email_domain || "",
                });
                setRecruiterEmail(generaldata?.restricted_email_domain[0] !== "" ? generaldata?.restricted_email_domain : []);
            } catch (error) {
                console.error("Error fetching user data", error);
            }finally {
                setCancels(false);
                setLoading(false);
            }
        };

        fetchUserData();
    }, [cancel]);
        // Handle image selection and clear site_logo error if changed
        const handleImageChange = (e) => {
            const file = e.target.files[0];
            if (file) {
                setFormData({ ...formData, site_logo: file });
                const reader = new FileReader();
                reader.onloadend = () => setPreview(reader.result);
                reader.readAsDataURL(file);
    
                // Clear site_logo error
                if (errors.site_logo) {
                    setErrors({ ...errors, site_logo: '' });
                }
            }
        };
        const handleImageChange1 = (e) => {
            const file = e.target.files[0];
            if (file) {
                setFormData({ ...formData, site_mini_logo: file });
                const reader = new FileReader();
                reader.onloadend = () => setpreviewMini(reader.result);
                reader.readAsDataURL(file);
    
                // Clear site_logo error
                if (errors.site_mini_logo) {
                    setErrors({ ...errors, site_mini_logo: '' });
                }
            }
        };
        // Clear specific errors when inputs are modified
        const handleInputChange = (e) => {
            const { name, value } = e.target;
            setFormData({ ...formData, [name]: value });
    
            // Clear the error for the changed field
            if (errors[name]) {
                setErrors({ ...errors, [name]: '' });
            }
        };
    
        const handlePhoneNumberChange = (e) => {
            const {name, value} = e.target;
            const inputElement = e.target;
            const cursorPosition = inputElement.selectionStart;

            let formattedInput = value.replace(/\D/g, '');
    
            if (formattedInput.length > 3 && formattedInput.length <= 6) {
                formattedInput = formattedInput.replace(/(\d{3})(\d+)/, '($1) $2'); // Format (123) 456
            } else if (formattedInput.length > 6) {
                formattedInput = formattedInput.replace(/(\d{3})(\d{3})(\d+)/, '($1) $2-$3'); // Format (123) 456-7890
            } else if (formattedInput.length <= 3) {
                formattedInput = `(${formattedInput}`; // Start formatting with open bracket (123
            }
    
            setFormData({ ...formData, [name]: formattedInput });
            
            // Clear phone number error
            if (errors[name]) {
                setErrors({ ...errors, [name]: '' });
            }
    
            // Adjust cursor position if needed
            setTimeout(() => {
                inputElement.selectionStart = cursorPosition + (formattedInput.length - value.length);
                inputElement.selectionEnd = inputElement.selectionStart;
            }, 0);
        };

        const handleInputChanger2 = (e) => {
        setInput2(e.target.value);
        if (errors.restricted_email_domain) {
            setErrors(prevErrors => ({ ...prevErrors, restricted_email_domain: undefined }));
        }
    };

    const handleKeyDown2 = (e) => {
        if (e.key === "Enter" && input2.trim()) {
            e.preventDefault();
            const newTag = input2.trim();
            if (!restricted_email_domain.includes(newTag)) {
                const updatedrestricted_email_domain = [...restricted_email_domain, newTag];
                setRecruiterEmail(updatedrestricted_email_domain);

                // Update the formData tag property to a comma-separated string or join the key_skills array as needed
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    restricted_email_domain: updatedrestricted_email_domain.join(", "), // Join key_skills into a single string if needed
                }));
            }
            setInput2("");
        }
    };

    const removeTag2 = (index) => {
        const updatedrestricted_email_domain = restricted_email_domain.filter((tag, i) => i !== index);
        setRecruiterEmail(updatedrestricted_email_domain);

        // Update the formData tag property to reflect the removed tag
        setFormData((prevFormData) => ({
            ...prevFormData,
            restricted_email_domain: updatedrestricted_email_domain.join(", "), // Update to a comma-separated string if needed
        }));
    };
    
        // Basic validation logic
        // const validate = () => {
        //     const newErrors = {};
        //     if (!formData.site_name) newErrors.site_name = 'First name is required';
        //     if (!formData.site_url) newErrors.site_url = 'Last name is required';
        //     if (!formData.site_email) newErrors.site_email = 'Email is required';
        //     else if (!/\S+@\S+\.\S+/.test(formData.site_email)) newErrors.site_email = 'Email is invalid';
        //     if (!formData.site_phone) newErrors.site_phone = 'Phone number is required';
        //     else if (!/^\(\d{3}\) \d{3}-\d{4}$/.test(formData.site_phone)) newErrors.site_phone = 'Phone number must be in the format (123) 456-7890';
        //     if (!formData.dob) newErrors.dob = 'Date of birth is required';
        //     if (!formData.password) newErrors.password = 'Password is required';
        //     if (!formData.password_confirmation) newErrors.password_confirmation = 'Please confirm your password';
        //     else if (formData.password !== formData.password_confirmation) newErrors.password_confirmation = 'Passwords do not match';
        //     if (formData.roles.length === 0) newErrors.roles = 'At least one Group is required';
    
        //     const password = formData.password;
        //     const passwordFormat = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+\\|{};:/?.<>])[\w!@#$%^&*()\-_=+\\|{};:/?.<>]{8,}$/;
        //     if (!passwordFormat.test(password)) {
        //         newErrors.password = 'Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and any one special character.';
        //     }
    
        //     const site_email = formData.site_email;
        //     const emailFormat = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        //     if (!emailFormat.test(site_email)) {
        //         newErrors.site_email = 'Please enter a valid site_email address.';
        //     }
    
        //     setErrors(newErrors);
        //     return Object.keys(newErrors).length === 0;
        // };
        
        const handleSubmit = async (e) => {
            e.preventDefault();
    
            const data = new FormData();
            data.append('site_name', formData.site_name);
            data.append('site_email', formData.site_email);
            data.append('site_phone', formData.site_phone);
            data.append('helpdesk_support_phone', formData.helpdesk_support_phone);
            data.append('site_url', formData.site_url);
            data.append('site_address', formData.site_address);
            data.append('site_city', formData.site_city);
            data.append('site_state', formData.site_state);
            data.append('site_pincode', formData.site_pincode);
            data.append('site_country', formData.site_country);
            data.append('restricted_email_domain', formData.restricted_email_domain);
            // data.append('site_mini_logo', formData.site_mini_logo);
            
            if (formData.site_logo) {
                data.append('site_logo', formData.site_logo);
            }
            if (formData.site_mini_logo) {
                data.append('site_mini_logo', formData.site_mini_logo);
            }
    
            setBtnLoading(true);
            try {
                const response = await apiService.postRequest('/admin/save-general-settings', data);
                if (response && response.success === true) {
                    // navigate('/user/member');
                    toast(response.message || "Settings saved successfully!");
                    setErrorMessage("");
                } else {
                    setErrorMessage(response.message || "Failed. Please try again");
                    if (response.errors) {
                        setErrors(response.errors);
                    }
                    if(response && response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                }
            } catch (error) {
                console.error('Error adding user:', error);
            } finally {
                setBtnLoading(false);
            }
        };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{sm:12}} container alignItems="center">
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Company Settings</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Company Settings <FontAwesomeIcon className='angleright' icon={faAngleRight} /> General</span>
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="flex-start" className="statusselectbtn my-5">
                        <SettingsTabs/>
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="center">
                    {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                        <form className='row justify-content-center w-100' onSubmit={handleSubmit}>
                            <Grid size={{sm:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                                <Grid size={{sm:5.5,xs:12}} container alignItems="center" className="profile_uploadlab">
                                    <h5>Company Logo</h5>
                                    <div className="profile-upload-wrapper">
                                        <label htmlFor="profile-upload-input" className="profile-upload-label_settings">
                                            {preview ? (
                                                <img src={preview} alt="Logo Preview" className="profile-preview width_seterforpreview" />
                                            ) : (
                                                <div className="placeholder-icon d-flex flex-column justify-content-center">
                                                    <FontAwesomeIcon className='upload_setting' icon={faArrowUpFromBracket} />
                                                    <span className='upload_setting_span'>Upload</span>
                                                </div>
                                            )}
                                        </label>
                                        <input
                                            id="profile-upload-input"
                                            type="file"
                                            accept="image/*"
                                            onChange={handleImageChange}
                                            style={{ display: 'none' }}
                                        />
                                    </div>
                                    {errors.site_logo && <p className='mt-3' style={{color:"red",width:"100%"}}>{errors.site_logo}</p>}
                                </Grid>
                                <Grid size={{sm:5.5,xs:12}} container alignItems="center" className="profile_uploadlab">
                                    <h5>Mini Logo</h5>
                                    <div className="profile-upload-wrapper">
                                        <label htmlFor="profile-upload-input1" className="profile-upload-label_settings">
                                            {preview ? (
                                                <img src={previewMini} alt="Mini Logo Preview" className="profile-preview width_seterforpreview" />
                                            ) : (
                                                <div className="placeholder-icon d-flex flex-column justify-content-center">
                                                    <FontAwesomeIcon className='upload_setting' icon={faArrowUpFromBracket} />
                                                    <span className='upload_setting_span'>Upload</span>
                                                </div>
                                            )}
                                        </label>
                                        <input
                                            id="profile-upload-input1"
                                            type="file"
                                            accept="image/*"
                                            onChange={handleImageChange1}
                                            style={{ display: 'none' }}
                                        />
                                    </div>
                                    {errors.site_mini_logo && <p className='mt-3' style={{color:"red",width:"100%"}}>{errors.site_mini_logo}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Company Name<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="site_name" value={formData.site_name} onChange={handleInputChange} onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}/>
                                    {errors.site_name && <p style={{color:"red"}}>{errors.site_name}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Website URL<small className='red_starimpo'>*</small></span>
                                    <input type="url" name="site_url" value={formData.site_url} onChange={handleInputChange}/>
                                    {errors.site_url && <p style={{color:"red"}}>{errors.site_url}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Email Id<small className='red_starimpo'>*</small></span>
                                    <input type="text"  name="site_email" value={formData.site_email} onChange={handleInputChange}/>
                                    {errors.site_email && <p style={{color:"red"}}>{errors.site_email}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Phone Number<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="site_phone" value={formData.site_phone} placeholder="(123) 456-7890" maxLength="14" onChange={handlePhoneNumberChange}/>
                                    {errors.site_phone && <p style={{color:"red"}}>{errors.site_phone}</p>}
                                </Grid>
                                <Grid size={{sm:12, xs:12}} container flexDirection="column" >
                                    <span>Address<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="site_address" value={formData.site_address} placeholder="address" onChange={handleInputChange}/>
                                    {errors.site_address && <p style={{color:"red"}}>{errors.site_address}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                    <span>Living State<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="site_state" value={formData.site_state} placeholder="address" onChange={handleInputChange}/>
                                    {errors.site_state && <p style={{color:"Red"}}>{errors.site_state}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                    <span>Living City<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="site_city" value={formData.site_city} placeholder="address" onChange={handleInputChange}/>
                                    {errors.site_city && <p style={{color:"Red"}}>{errors.site_city}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                    <span>Living Country<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="site_country" value={formData.site_country} placeholder="address" onChange={handleInputChange}/>
                                    {errors.site_country && <p style={{color:"Red"}}>{errors.site_country}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Zip Code<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="site_pincode" value={formData.site_pincode} placeholder="zipcode" onChange={handleInputChange}/>
                                    {errors.site_pincode && <p style={{color:"red"}}>{errors.site_pincode}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Helpdesk Support Number<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="helpdesk_support_phone" value={formData.helpdesk_support_phone} placeholder="(123) 456-7890" maxLength="14" onChange={handlePhoneNumberChange}/>
                                    {errors.helpdesk_support_phone && <p style={{color:"red"}}>{errors.helpdesk_support_phone}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                    <span>Restricted Email Domain</span>
                                    <input
                                        type="email"
                                        value={input2}
                                        onChange={handleInputChanger2}
                                        onKeyDown={handleKeyDown2}
                                        placeholder="Type and press Enter"
                                        style={styles.input}
                                    />
                                    <small style={{color:"#1A5298", fontWeight:"500"}}><b>Note:</b> Please press enter button after type</small>
                                    <div style={styles.tagContainer} className='mt-2'>
                                        {restricted_email_domain.map((tag, index) => (
                                        <div key={index} style={styles.tag}>
                                            {tag}
                                            <button
                                            type="button"
                                            style={styles.removeButton}
                                            onClick={() => removeTag2(index)}
                                            >
                                            &times;
                                            </button>
                                        </div>
                                        ))}
                                    </div>
                                    {errors.restricted_email_domain && <p style={{color:"Red"}}>{errors.restricted_email_domain}</p>}
                                </Grid>
                            {errorsmessage && <p style={{ color: 'red' ,width:'100%' }}>{errorsmessage}</p>}
                            </Grid>
                            <Grid size={{sm:12,xs:12}} container className="gap-3 my-3">
                                <button type='button' className='registersendbtn1' onClick={()=>setCancels(true)}>Cancel</button>
                                <button type="submit" className='registersendbtn2'>{btnloading ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Save'}</button>
                            </Grid>
                        </form>
                    </>}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default SettingsGeneral
